export const NO_DATA = "No Data";
